import { gql } from '@apollo/client';
import {
  UserSettingsRequestFields,
  UserAddressRequestFields,
} from './fragments';

export const EDIT_USER = gql`
  mutation EditUser($input: UserUpdateInput!) {
    editUser(input: $input) {
      ...UserSettingsRequestFields
    }
  }
  ${UserSettingsRequestFields}
`;

export const EDIT_BRAND_USER = gql`
  mutation EditAgency($input: AgencyEditInput!) {
    editAgency(input: $input) {
      agencyDetails {
        city
        companyDomains
        companyName
        country
        id
        jobTitle
        latitude
        longitude
        state
      }
      avatarKey
      email
      firstName
      lastName
      id
      phoneNumber
    }
  }
`;

export const CREATE_ADDRESS = gql`
  mutation CreateAddress($input: CreateAddressInput!) {
    createAddress(input: $input) {
      ...UserAddressRequestFields
    }
  }
  ${UserAddressRequestFields}
`;

export const UPDATE_ADDRESS = gql`
  mutation UpdateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      ...UserAddressRequestFields
    }
  }
  ${UserAddressRequestFields}
`;

export const DELETE_ADDRESS = gql`
  mutation DeleteAddress($id: String!) {
    deleteAddress(id: $id) {
      id
    }
  }
`;

export const ADMIN_DELETE_ACCOUNT = gql`
  mutation AdminDeleteAccount($input: AdminDeleteAccountInput!) {
    adminDeleteAccount(input: $input) {
      id
      deletedAt
    }
  }
`;

export const ADMIN_CLEAR_DELETE_REQUEST = gql`
  mutation AdminClearDeleteRequest($input: AdminClearDeleteRequestInput!) {
    adminClearDeleteRequest(input: $input) {
      id
      deleteRequestedAt
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: String!) {
    deleteUser(id: $id) {
      id
      lastName
      firstName
      email
      phoneNumber
      storeDetails {
        id
        socialMediaLink
      }
      createdAt
      activatedAt
      role
      isOnboarded
      slug
    }
  }
`;

export const REJECT_STORE_USER = gql`
  mutation RejectAwaitingApprovalStore($input: RejectAwaitingStoreInput!) {
    rejectAwaitingApprovalStore(input: $input) {
      id
      lastName
      firstName
      email
      phoneNumber
      storeDetails {
        id
        socialMediaLink
      }
      createdAt
      activatedAt
      role
      isOnboarded
      slug
    }
  }
`;

export const REINSTATE_REJECTED_STORE_USER = gql`
  mutation ReinstateRejectedStore($input: ReinstateRejectedStoreInput!) {
    reinstateRejectedStore(input: $input) {
      id
      lastName
      firstName
      email
      phoneNumber
      storeDetails {
        id
        socialMediaLink
      }
      createdAt
      activatedAt
      role
      isOnboarded
      slug
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation UpdateUserRole($input: UpdateUserRoleInput!) {
    updateUserRole(input: $input) {
      id
      role
      subtype
      status
    }
  }
`;

export const ADMIN_CHANGE_PASSWORD = gql`
  mutation AdminChangePassword($input: AdminChangePasswordInput!) {
    adminChangePassword(input: $input) {
      id
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      id
    }
  }
`;
